<template>
  <generic-modal :modal-key="'failed_exchange_stars'" :has-extra-modal-class="'popup_box op_down modal_cont oups'"
                 @close="$emit('close')">
    <template slot="content">
      <h1>{{ getTranslations.home_exchange_fail_modal_confirm }}</h1>
      <img src="static/images/ghost.png" class="op_down_img">
      <p>{{ getTranslations.home_exchange_failed_modal_confirm_oups }} <a :href="getTranslations.home_exchange_fail_modal_support_link" >{{ getTranslations.home_exchange_fail_modal_support }}</a>
      </p>
    </template>
  </generic-modal>
</template>

<script>
  /* eslint no-console: "off", no-param-reassign: ["error", { "props": false }], no-use-before-define: ["error", { "variables": false }] */
import { mapGetters } from 'vuex';
import GenericModal from '../../sharedcomponents/GenericModal';

export default {
  name: 'failedExchange',
  components: { GenericModal },
  computed: {
    ...mapGetters('i18n', [
      'getTranslations',
    ]),
  },
};
</script>



// WEBPACK FOOTER //
// src/components/home/modals/stars/FailedExchange.vue